import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const LeadTypePill = (props) => {
  const {
    leadType,
    gciPrice,
    exclusive = false,
  } = props;

  const classList = ['lead-type-pill', 'headline-4'];

  if (exclusive) {
    classList.push('exclusive');
  }
  return (
    <div className={classList.join(' ')}>
      {
        exclusive
          ? `${gciPrice} Exclusive ${leadType}`
          : `${gciPrice} ${leadType}`
      }
    </div>
  );
};

export default LeadTypePill;

LeadTypePill.propTypes = {
  leadType: PropTypes.string.isRequired,
  gciPrice: PropTypes.string.isRequired,
  exclusive: PropTypes.bool,
};
